import {
  WbSelectInline,
  WbSelectInlineItem,
} from '@agilelab/plugin-wb-platform';
import { FeatureRequestStatus } from '@agilelab/plugin-wb-builder-common';
import { useFeatureRequestMutations } from '../../hooks/useFeatureRequestMutations';
import { CircularProgress } from '@material-ui/core';

const STATUS_OPTIONS = Object.values(FeatureRequestStatus);

interface FeatureRequestStatusUpdateProps {
  featureRequestId: string;
  currentStatus: FeatureRequestStatus;
}

export const FeatureRequestStatusUpdate = ({
  featureRequestId,
  currentStatus,
}: FeatureRequestStatusUpdateProps) => {
  const { updateStatus } = useFeatureRequestMutations();

  const handleChange = (value: string) => {
    if (value !== currentStatus) {
      updateStatus.mutate({
        id: featureRequestId,
        status: value as FeatureRequestStatus,
      });
    }
  };

  if (updateStatus.isLoading) {
    return <CircularProgress size={20} />;
  }

  return (
    <WbSelectInline
      title="Status:"
      value={currentStatus}
      onChange={handleChange}
      aria-label="Update feature request status"
    >
      {STATUS_OPTIONS.map(s => (
        <WbSelectInlineItem key={s} value={s}>
          {s.replace('_', ' ')}
        </WbSelectInlineItem>
      ))}
    </WbSelectInline>
  );
};
